<template>
  <div class="right-consume">
    <div class="table-wrapper">
      <div class="table-filter">
        <div class="filter">
          <a-input
            placeholder="请输入助学师"
            style="width: 130px"
            class="filter-selection"
            allow-clear
            v-model="form.teacherName"
          />
          <a-input
            placeholder="请输入小组名称"
            style="width: 144px"
            class="filter-selection"
            allow-clear
            v-model="form.groupName"
          />
          <template>
            <span class="filter-selection">学年学期</span>
            <YearSemesterSelect ref="yearAndSemester" class="filter-selection" @updateYearAndSemester="updateYearAndSemester" />
          </template>
          <a-input
            placeholder="请输入学生姓名"
            style="width: 146px"
            class="filter-selection"
            allow-clear
            v-model="form.studentName"
          />
          <a-input
            placeholder="请输入学生手机号"
            style="width: 166px"
            class="filter-selection"
            allow-clear
            v-model="form.telephone"
            max-length="11"
          />
          <template>
            <a-button type="primary" class="filter-selection" @click="doSearch">
              搜索
            </a-button>
          </template>
          <template>
            <a-button @click="doReset" class="ant-btn-secondary">
              重置
            </a-button>
          </template>
        </div>
        <div class="filter current-remain">
          <a-radio-group :value="form.auditStatus" @change="handleRightTypeChange" :options="CONSUME_INTERVIEW_STATUS" />
          <CardTypes @dataChange="cardTypesChange" ref="cardTypes" :no-types="[18]" />
        </div>
      </div>
      <div class="list-box">
        <a-spin :spinning="spinning" tip="Loading..." :style="{width: '100%'}">
          <div class="group-list-box">
            <a-table
              :loading="loading"
              :columns="columns"
              :data-source="list"
              :pagination="false"
              row-key="id"
              :scroll="scroll"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }"
            >
              <!-- 当前名称 -->
              <span slot="studentName" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    {{ text }}
                  </template>
                  <p style="height: 20px; overflow: hidden;">{{ text }}</p>
                </a-tooltip>
              </span>
              <!-- 当前权益 -->
              <span slot="currentRights" slot-scope="text, record">
                <span>
                  <span>{{ JURISDICTION_TYPE[record.jurisdiction] }}</span>
                  <span v-if="record.jurisdiction === JURISDICTION_TYPE.EXPER_JUR" style="color: #98A2B2">
                    <br />
                    {{ $moment(record.endTime).format('YYYY.MM.DD') }}  (剩余{{ record.experienceDays }}天)
                  </span>
                </span>
              </span>
              <!-- 学年学期 -->
              <span slot="yearSemester" slot-scope="text, record">
                {{ record.year > 0 && record.semester ? (record.year + ' ' + record.semester) : '--' }}
              </span>
              <!-- 权益包类型 -->
              <span slot="rightsType" slot-scope="text, record">{{ getRightType(record.cardType) }}</span>
              <!-- 操作 -->
              <span slot="operation" slot-scope="text, record">
                <!-- 高中全科权益也需要审核 -->
                <span v-if="record.jurisdiction === JURISDICTION_TYPE.ALL_JUR && !SENIOR_CARD_TYPES.includes(record.cardType)">
                  小初全科权益，自动通过 <Tip />
                </span>
                <span v-else>
                  <span v-if="record.auditStatus === AUDIT_STATUS.WAIT">
                    <span v-if="record.enableStatus === 1">
                      <a-button class="ant-btn-secondary" @click="handleApprove(record)" :disabled="notOneTwoType(record.cardType)" style="margin-right: 8px;">审核通过</a-button>
                      <a-button class="ant-btn-secondary" @click="handleReject(record)" :disabled="notOneTwoType(record.cardType)">审核不通过</a-button>
                      <Tip v-if="record.auditorName" :auditor-name="record.auditorName" :audit-time="record.auditTime" />
                    </span>
                    <span v-else>学生已不在组中，无需审核</span>
                  </span>
                  <span v-else-if="record.auditStatus === AUDIT_STATUS.APPROVE">
                    审核通过
                    <Tip :auditor-name="record.auditorName" :audit-time="record.auditTime" />
                  </span>
                  <span v-else>
                    审核不通过
                    <Tip :auditor-name="record.auditorName" :audit-time="record.auditTime" />
                    <a-button v-if="record.enableStatus === 1" type="t-link" @click="handleReApprove(record)" :disabled="notOneTwoType(record.cardType)">重新审核</a-button>
                  </span>
                </span>
              </span>
            </a-table>
            <div class="pagination">
              <a-pagination
                v-show="pagination.total > 0"
                v-model="pagination.current"
                :total="pagination.total"
                :page-size="pagination.pageSize"
                :disabled="selectedRowKeys.length > 0"
                @change="handleChangePageNum"
              />
            </div>
            <div v-if="selectedRowKeys.length > 0" class="batch-approval">
              <div class="ba-content">
                <span>已选择 {{ selectedRowKeys.length }} 个</span>
                <a-button type="primary" @click="handleApproveBatch">
                  批量通过
                </a-button>
                <a-button @click="handleRejectBatch">
                  批量不通过
                </a-button>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import YearSemesterSelect from '@/components/YearSemesterSelect.vue'
import { CONSUME_INTERVIEW_STATUS, JURISDICTION_TYPE, RIGHT_PACKAGE_TYPE, AUDIT_STATUS, UPD_STATUS, SENIOR_CARD_TYPES } from '../constants.js'
import filters from '@/filters'
import { columns } from './columns'
import Tip from './tip'
import CardTypes from '@/components/CardTypes.vue'

export default {
  components: {
    YearSemesterSelect,
    Tip,
    CardTypes
  },
  data() {
    this.filters = filters
    return {
      CONSUME_INTERVIEW_STATUS,
      RIGHT_PACKAGE_TYPE,
      JURISDICTION_TYPE,
      SENIOR_CARD_TYPES,
      AUDIT_STATUS,
      scroll: { x: true, y: 'calc(100vh - 400px)' },
      loading: false,
      form: {
        teacherName: '',
        groupName: '',
        year: '',
        semester: '',
        studentName: '',
        telephone: '',
        auditStatus: -1
      },
      pagination: {
        pageSize: 20,
        current: 1
      },
      columns,
      list: [],
      selectedRowKeys: [],
      spinning: false,
      cardTypesData: []
    }
  },
  created() {
    // 获取列表数据
    this.getList()
  },
  methods: {
    async getRemainCount() {
      const reaminList = await this.$service.studentRight.insQuota({ cardType: [11, 12, 16, 17] })
      return reaminList
    },
    async getList(resetSelectedRowKeys = true) {
      try {
        resetSelectedRowKeys && (this.selectedRowKeys = [])
        this.loading = true
        const result = await this.$service.studentRight.getList({
          ...this.form,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        })
        this.list = result.list || []
        this.selectedRowKeys.length && this.list.forEach(l => {
          if (this.selectedRowKeys.includes(l.id)) {
            const p = this.getCheckboxProps(l)
            if (p.props && p.props.disabled) {
              this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(l.id), 1)
            }
          }
        })
        this.pagination.total = result.itemTotal
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    handleRightTypeChange({ target: { value } }) {
      this.form.auditStatus = value
      this.pagination.current = 1
      this.$refs.cardTypes.getData()
      this.getList()
    },
    updateYearAndSemester(opts) {
      this.form.year = opts.year === '全部' ? '' : opts.year
      this.form.semester = opts.semester === '全部' ? '' : opts.semester
    },
    doSearch() {
      this.pagination.current = 1
      this.$refs.cardTypes.getData()
      this.getList()
    },
    doReset() {
      Object.keys(this.form).forEach(item => {
        this.form[item] = item === 'auditStatus' ? -1 : ''
      })
      this.$refs.yearAndSemester.clearSelect()
      this.pagination.current = 1
      this.$nextTick(() => {
        this.$refs.cardTypes.getData()
        this.getList()
      })
    },
    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },
    async handleApprove(record) {
      const typeName = RIGHT_PACKAGE_TYPE[record.cardType]
      // 判断是否有数量
      const list = await this.getRemainCount()
      const remainInfo = (list || []).find(item => item.cardType === record.cardType)
      if (remainInfo.residueNumber <= 0) {
        this.$message.error(`操作失败，机构${typeName}权益包数量不足，请去购买。`)
        return
      }
      this.$confirm({
        title: '',
        content: h => <div>
                        <p>机构剩余{typeName}权益包名额为：{remainInfo.residueNumber}</p>
                        <p>审核通过后，将扣减1个{typeName}权益包名额。</p>
                      </div>,
        onOk: () =>
          new Promise(resolve => {
            this.aduit(record, UPD_STATUS.APPROVE, resolve)
          })
      })
    },
    handleReject(record) {
      const typeName = RIGHT_PACKAGE_TYPE[record.cardType]
      this.$confirm({
        title: '',
        content: h => <div>
                        <p>确认该学生审核不通过吗？</p>
                        <p>审核不通过，不会占用机构的{typeName}权益包名额</p>
                      </div>,
        onOk: () =>
          new Promise(resolve => {
            this.aduit(record, UPD_STATUS.NOTAPPROVE, resolve)
          })
      })
    },
    async handleReApprove(record) {
      await this.aduit(record, UPD_STATUS.REAUDIT, () => {})
    },
    async aduit(record, auditStatus, resolve) {
      const { id, userId, cardType, classTypeId } = record
      try {
        await this.$service.studentRight.rightApproval({
          id,
          userId,
          cardType,
          auditStatus,
          classTypeId
        })
        resolve()
        this.getList()
        this.$refs.cardTypes.getData()
      } catch (e) {
        resolve()
      }
    },
    getRemainDays (endTime) {
      const diff = endTime - new Date().getTime()
      const remainDays = Math.ceil(diff / (1000 * 60 * 60 * 24))
      return `${remainDays > 14 ? 14 : remainDays}天`
    },
    getRightType(cardType) {
      return [11, 12, 16, 17].indexOf(cardType) !== -1 ? RIGHT_PACKAGE_TYPE[cardType] : '--'
    },
    notOneTwoType(cardType) {
      return [11, 12, 16, 17].indexOf(cardType) === -1
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: (record.jurisdiction === JURISDICTION_TYPE.ALL_JUR && !SENIOR_CARD_TYPES.includes(record.cardType)) || record.auditStatus !== AUDIT_STATUS.WAIT || record.enableStatus !== 1 || this.notOneTwoType(record.cardType)
        }
      }
    },
    handleBatch(isPass) {
      const selectedRow = this.list.filter(item => this.selectedRowKeys.includes(item.id))
      if (isPass) {
        const checkBatchData = selectedRow.reduce((prev, cur) => {
          prev[cur.cardType] = prev[cur.cardType] ? prev[cur.cardType] + 1 : 1
          return prev
        }, {})
        if (this.cardTypesData.findIndex(c => c.residueNumber < checkBatchData[c.cardType]) > -1) {
          this.$message.warn('剩余权益不足，请检查后重试')
          return
        }
      }
      const param = selectedRow.map(item => ({
        studentUserId: item.userId,
        cardType: item.cardType,
        classTypeId: item.classTypeId,
        studentCourseId: item.id
      }))
      this.spinning = true
      const fn = isPass ? this.$service.studentRight.batchPass : this.$service.studentRight.batchReject
      fn(param).then(res => {
        this.$message.success(isPass ? '批量通过处理成功！' : '批量不通过处理成功！')
        this.getList()
        this.$refs.cardTypes.getData()
      }, res => {
        if (Array.isArray(res.body)) {
          this.selectedRowKeys = res.body
        }
        this.getList(false)
        this.$refs.cardTypes.getData()
      }).finally(() => {
        this.spinning = false
      })
    },
    handleApproveBatch() {
      this.handleBatch(TextTrackCueList)
    },
    handleRejectBatch() {
      this.handleBatch(false)
    },
    cardTypesChange(data) {
      this.cardTypesData = data
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/static/css/base.less';
:deep(.ant-table-fixed-right) {
  .ant-table-body-outer {
    margin-bottom: -6px !important;
  }
}
.right-consume {
  // 解决固定列底部预留的空隙
  :deep(.ant-table-fixed-left) {
    height: -webkit-fill-available;
    .ant-table-body-outer {
      margin-bottom: -6px !important;
      // &::-webkit-scrollbar {
      //   display: none !important;
      // }
    }
  }
}
.right-consume {
  .filter-selection {
    margin-right: 8px;
  }
  .table-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    overflow: hidden;
    background: @gray-10;

    .table-filter {
      margin-bottom: 16px;
      .filter-title {
        margin-right: 12px;
      }

      .filter-title:not(:first-child) {
        margin-left: 20px;
      }

      .current-remain {
        display: flex;
        justify-content: space-between;
        margin-top:10px;
        padding-right:12px;
      }
      .approve-info {
        padding: 0 4px;
      }
    }
    .list-box {
      flex: 1;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      .group-list-box {
        flex: 1;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
        padding-right: 10px;
        position: relative;
        .table {
          flex: 1;
          overflow: auto;
        }
        .pagination {
          text-align: right;
          padding-top: 12px;
        }
        .batch-approval {
          position: absolute;
          top: 40px;
          right: 10px;
          width: 277px;
          height: calc(100% - 85px);
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99;
          border-left: 1px solid @gray-6;
          border-right: 1px solid @gray-6;
          .ba-content {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .ant-btn-primary {
              margin: 20px 0 15px 0;
              width: 112px;
            }
          }
        }
      }
    }
  }

  .red-color {
    color: red;
  }
}

</style>
